export default __webpack_public_path__ + "static/edutoolkit_Edutoolkit-2df050316f7be807020cd5f4e9b7dc62.png";